import { c as _c } from "react/compiler-runtime";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "@/react-query/api-client";
import { API_ROUTES } from "@/react-query/api-routes";
import type { ApiEnvelope } from "@/react-query/api-types";
import { CACHE_TIME } from "@/react-query/cache-times";
import { queryKeys } from "@/react-query/query-keys";
import { parseAuthMeInfo, parseProfile } from "./profile-parsers";
import type { AuthenticatedUserInfo, Profile } from "./types";
export function useProfileQuery(t0) {
  const $ = _c(3);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = queryKeys.profileDetail();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      queryKey: t1,
      queryFn: _temp,
      enabled,
      staleTime: CACHE_TIME.BALANCED,
      gcTime: CACHE_TIME.PERSISTENT
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useQuery(t2);
}
async function _temp() {
  const response = await apiClient(API_ROUTES.profileDetail);
  return parseProfile(response.data);
}
export function useAuthenticatedUserQuery(t0) {
  const $ = _c(3);
  const enabled = t0 === undefined ? true : t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = queryKeys.authenticatedUser();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== enabled) {
    t2 = {
      queryKey: t1,
      queryFn: _temp2,
      enabled,
      staleTime: CACHE_TIME.BALANCED,
      gcTime: CACHE_TIME.PERSISTENT
    };
    $[1] = enabled;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return useQuery(t2);
}

/** Temporary RTK-compatible query signatures keep consumer migration mechanical. */
async function _temp2() {
  const response = await apiClient(API_ROUTES.authMe);
  return parseAuthMeInfo(response.data);
}
export function useGetProfileQuery(_arg, options) {
  return useProfileQuery(!options?.skip);
}
export function useAutheMeQuery(_arg, options) {
  return useAuthenticatedUserQuery(!options?.skip);
}
export function useUpdateProfileMutation() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp3,
      onSuccess: profile_0 => {
        queryClient.setQueryData(queryKeys.profileDetail(), profile_0);
        queryClient.invalidateQueries({
          queryKey: queryKeys.profileDetail()
        });
      }
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
async function _temp3(profile) {
  const response = await apiClient(API_ROUTES.profileDetail, {
    method: "PUT",
    body: profile
  });
  return parseProfile(response.data);
}
export function useAcceptPrivacyPolicyMutation() {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = {
      mutationFn: _temp4,
      onSuccess: () => queryClient.invalidateQueries({
        queryKey: queryKeys.authenticatedUser()
      })
    };
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useMutation(t0);
}
function _temp4() {
  return apiClient(API_ROUTES.acceptPrivacyPolicy, {
    method: "POST"
  });
}